/**
 * U.S. State to Region Mapping
 * Based on the standard U.S. Map Regions classification
 */

export const US_REGIONS = {
  PACIFIC: 'Pacific',
  MOUNTAIN: 'Mountain',
  WEST_NORTH_CENTRAL: 'West North Central',
  EAST_NORTH_CENTRAL: 'East North Central',
  NEW_ENGLAND: 'New England',
  MIDDLE_ATLANTIC: 'Middle Atlantic',
  WEST_SOUTH_CENTRAL: 'West South Central',
  EAST_SOUTH_CENTRAL: 'East South Central',
  SOUTH_ATLANTIC: 'South Atlantic'
};

// State to Region Mapping
export const STATE_REGION_MAP = {
  // Pacific Region
  'Alaska': US_REGIONS.PACIFIC,
  'California': US_REGIONS.PACIFIC,
  'Hawaii': US_REGIONS.PACIFIC,
  'Oregon': US_REGIONS.PACIFIC,
  'Washington': US_REGIONS.PACIFIC,
  
  // Mountain Region
  'Arizona': US_REGIONS.MOUNTAIN,
  'Colorado': US_REGIONS.MOUNTAIN,
  'Idaho': US_REGIONS.MOUNTAIN,
  'Montana': US_REGIONS.MOUNTAIN,
  'Nevada': US_REGIONS.MOUNTAIN,
  'New Mexico': US_REGIONS.MOUNTAIN,
  'Utah': US_REGIONS.MOUNTAIN,
  'Wyoming': US_REGIONS.MOUNTAIN,
  
  // West North Central Region
  'Iowa': US_REGIONS.WEST_NORTH_CENTRAL,
  'Kansas': US_REGIONS.WEST_NORTH_CENTRAL,
  'Minnesota': US_REGIONS.WEST_NORTH_CENTRAL,
  'Missouri': US_REGIONS.WEST_NORTH_CENTRAL,
  'Nebraska': US_REGIONS.WEST_NORTH_CENTRAL,
  'North Dakota': US_REGIONS.WEST_NORTH_CENTRAL,
  'South Dakota': US_REGIONS.WEST_NORTH_CENTRAL,
  
  // East North Central Region
  'Illinois': US_REGIONS.EAST_NORTH_CENTRAL,
  'Indiana': US_REGIONS.EAST_NORTH_CENTRAL,
  'Michigan': US_REGIONS.EAST_NORTH_CENTRAL,
  'Ohio': US_REGIONS.EAST_NORTH_CENTRAL,
  'Wisconsin': US_REGIONS.EAST_NORTH_CENTRAL,
  
  // New England Region
  'Connecticut': US_REGIONS.NEW_ENGLAND,
  'Maine': US_REGIONS.NEW_ENGLAND,
  'Massachusetts': US_REGIONS.NEW_ENGLAND,
  'New Hampshire': US_REGIONS.NEW_ENGLAND,
  'Rhode Island': US_REGIONS.NEW_ENGLAND,
  'Vermont': US_REGIONS.NEW_ENGLAND,
  
  // Middle Atlantic Region
  'New Jersey': US_REGIONS.MIDDLE_ATLANTIC,
  'New York': US_REGIONS.MIDDLE_ATLANTIC,
  'Pennsylvania': US_REGIONS.MIDDLE_ATLANTIC,
  
  // West South Central Region
  'Arkansas': US_REGIONS.WEST_SOUTH_CENTRAL,
  'Louisiana': US_REGIONS.WEST_SOUTH_CENTRAL,
  'Oklahoma': US_REGIONS.WEST_SOUTH_CENTRAL,
  'Texas': US_REGIONS.WEST_SOUTH_CENTRAL,
  
  // East South Central Region
  'Alabama': US_REGIONS.EAST_SOUTH_CENTRAL,
  'Kentucky': US_REGIONS.EAST_SOUTH_CENTRAL,
  'Mississippi': US_REGIONS.EAST_SOUTH_CENTRAL,
  'Tennessee': US_REGIONS.EAST_SOUTH_CENTRAL,
  
  // South Atlantic Region
  'Delaware': US_REGIONS.SOUTH_ATLANTIC,
  'Florida': US_REGIONS.SOUTH_ATLANTIC,
  'Georgia': US_REGIONS.SOUTH_ATLANTIC,
  'Maryland': US_REGIONS.SOUTH_ATLANTIC,
  'North Carolina': US_REGIONS.SOUTH_ATLANTIC,
  'South Carolina': US_REGIONS.SOUTH_ATLANTIC,
  'Virginia': US_REGIONS.SOUTH_ATLANTIC,
  'West Virginia': US_REGIONS.SOUTH_ATLANTIC,
  'District of Columbia': US_REGIONS.SOUTH_ATLANTIC,
};

// State abbreviation to region direct mapping
// Format: Abbreviation -> Region
const STATE_ABBREV_TO_REGION = {
  // Pacific
  'AK': US_REGIONS.PACIFIC,
  'CA': US_REGIONS.PACIFIC,
  'HI': US_REGIONS.PACIFIC,
  'OR': US_REGIONS.PACIFIC,
  'WA': US_REGIONS.PACIFIC,
  
  // Mountain
  'AZ': US_REGIONS.MOUNTAIN,
  'CO': US_REGIONS.MOUNTAIN,
  'ID': US_REGIONS.MOUNTAIN,
  'MT': US_REGIONS.MOUNTAIN,
  'NV': US_REGIONS.MOUNTAIN,
  'NM': US_REGIONS.MOUNTAIN,
  'UT': US_REGIONS.MOUNTAIN,
  'WY': US_REGIONS.MOUNTAIN,
  
  // West North Central
  'IA': US_REGIONS.WEST_NORTH_CENTRAL,
  'KS': US_REGIONS.WEST_NORTH_CENTRAL,
  'MN': US_REGIONS.WEST_NORTH_CENTRAL,
  'MO': US_REGIONS.WEST_NORTH_CENTRAL,
  'NE': US_REGIONS.WEST_NORTH_CENTRAL,
  'ND': US_REGIONS.WEST_NORTH_CENTRAL,
  'SD': US_REGIONS.WEST_NORTH_CENTRAL,
  
  // East North Central
  'IL': US_REGIONS.EAST_NORTH_CENTRAL,
  'IN': US_REGIONS.EAST_NORTH_CENTRAL,
  'MI': US_REGIONS.EAST_NORTH_CENTRAL,
  'OH': US_REGIONS.EAST_NORTH_CENTRAL,
  'WI': US_REGIONS.EAST_NORTH_CENTRAL,
  
  // New England
  'CT': US_REGIONS.NEW_ENGLAND,
  'ME': US_REGIONS.NEW_ENGLAND,
  'MA': US_REGIONS.NEW_ENGLAND,
  'NH': US_REGIONS.NEW_ENGLAND,
  'RI': US_REGIONS.NEW_ENGLAND,
  'VT': US_REGIONS.NEW_ENGLAND,
  
  // Middle Atlantic
  'NJ': US_REGIONS.MIDDLE_ATLANTIC,
  'NY': US_REGIONS.MIDDLE_ATLANTIC,
  'PA': US_REGIONS.MIDDLE_ATLANTIC,
  
  // West South Central
  'AR': US_REGIONS.WEST_SOUTH_CENTRAL,
  'LA': US_REGIONS.WEST_SOUTH_CENTRAL,
  'OK': US_REGIONS.WEST_SOUTH_CENTRAL,
  'TX': US_REGIONS.WEST_SOUTH_CENTRAL,
  
  // East South Central
  'AL': US_REGIONS.EAST_SOUTH_CENTRAL,
  'KY': US_REGIONS.EAST_SOUTH_CENTRAL,
  'MS': US_REGIONS.EAST_SOUTH_CENTRAL,
  'TN': US_REGIONS.EAST_SOUTH_CENTRAL,
  
  // South Atlantic
  'DE': US_REGIONS.SOUTH_ATLANTIC,
  'FL': US_REGIONS.SOUTH_ATLANTIC,
  'GA': US_REGIONS.SOUTH_ATLANTIC,
  'MD': US_REGIONS.SOUTH_ATLANTIC,
  'NC': US_REGIONS.SOUTH_ATLANTIC,
  'SC': US_REGIONS.SOUTH_ATLANTIC,
  'VA': US_REGIONS.SOUTH_ATLANTIC,
  'WV': US_REGIONS.SOUTH_ATLANTIC,
  'DC': US_REGIONS.SOUTH_ATLANTIC,
};

/**
 * Get region name by state name or abbreviation
 * @param {string} state - State name or abbreviation
 * @returns {string|null} - Region name or null if not found
 */
export const getRegionByState = (state) => {
  if (!state) {
    return null;
  }
  
  // Trim and handle case insensitivity
  const normalizedState = state.trim();
  
  // First, try direct abbreviation to region mapping (most efficient)
  const upperState = normalizedState.toUpperCase();
  if (STATE_ABBREV_TO_REGION[upperState]) {
    return STATE_ABBREV_TO_REGION[upperState];
  }
  
  // Then try exact match with full state name
  if (STATE_REGION_MAP[normalizedState]) {
    return STATE_REGION_MAP[normalizedState];
  }
  
  // Try case-insensitive match with full state name
  const stateKey = Object.keys(STATE_REGION_MAP).find(
    key => key.toLowerCase() === normalizedState.toLowerCase()
  );
  
  if (stateKey) {
    return STATE_REGION_MAP[stateKey];
  }
  
  return null;
};

/**
 * Extract state from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - State name or abbreviation
 */
export const extractStateFromGeocodingResult = (result) => {
  if (!result) {
    return null;
  }
  
  // Strategy 1: Check if the result itself is a US region/state
  if (result.id && result.id.startsWith('region.')) {
    const shortCode = result.properties?.short_code;
    
    if (shortCode) {
      const parts = shortCode.split('-');
      
      if (parts.length === 2 && parts[0] === 'US') {
        return parts[1];
      }
    }
  }
  
  // Strategy 2: Check result.context for region
  if (!result.context) {
    return null;
  }
  
  // Find the region context item (state level)
  const stateContext = result.context.find(
    item => item.id && item.id.startsWith('region.')
  );
  
  if (stateContext) {
    // Extract state abbreviation from short_code (e.g., "US-CA" -> "CA")
    if (stateContext.short_code) {
      const parts = stateContext.short_code.split('-');
      
      if (parts.length === 2 && parts[0] === 'US') {
        return parts[1];
      }
    }
  }
  
  return null;
};

/**
 * Get region from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result object
 * @returns {string|null} - Region name or null
 */
export const getRegionFromGeocodingResult = (result) => {
  const state = extractStateFromGeocodingResult(result);
  const region = getRegionByState(state);
  return region;
};

/**
 * Extract city from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - City name or null
 */
export const extractCityFromGeocodingResult = (result) => {
  if (!result) {
    return null;
  }
  
  // Strategy 1: Check if the result itself is a place (city)
  if (result.id && result.id.startsWith('place.')) {
    return result.text || null;
  }
  
  // Strategy 2: Check result.context for place
  if (!result.context) {
    return null;
  }
  
  // Find the place context item (city level)
  const cityContext = result.context.find(
    item => item.id && item.id.startsWith('place.')
  );
  
  if (cityContext && cityContext.text) {
    return cityContext.text;
  }
  
  return null;
};

/**
 * Extract country from Mapbox geocoding result
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - Country name or null
 */
export const extractCountryFromGeocodingResult = (result) => {
  if (!result) {
    return null;
  }
  
  // Strategy 1: Check if the result itself is a country
  if (result.id && result.id.startsWith('country.')) {
    return result.text || null;
  }
  
  // Strategy 2: Check result.context for country
  if (!result.context) {
    return null;
  }
  
  // Find the country context item
  const countryContext = result.context.find(
    item => item.id && item.id.startsWith('country.')
  );
  
  if (countryContext && countryContext.text) {
    return countryContext.text;
  }
  
  return null;
};

/**
 * Extract full state name from Mapbox geocoding result (not abbreviation)
 * @param {object} result - Mapbox geocoding result
 * @returns {string|null} - Full state name or null
 */
export const extractStateNameFromGeocodingResult = (result) => {
  if (!result) {
    return null;
  }
  
  // Check if the result itself is a US region/state
  if (result.id && result.id.startsWith('region.')) {
    return result.text || null;
  }
  
  // Check result.context for region
  if (!result.context) {
    return null;
  }
  
  // Find the region context item (state level)
  const stateContext = result.context.find(
    item => item.id && item.id.startsWith('region.')
  );
  
  if (stateContext && stateContext.text) {
    return stateContext.text;
  }
  
  return null;
};

// Export all region options for Select component
export const REGION_OPTIONS = Object.values(US_REGIONS).filter(
  (value, index, self) => self.indexOf(value) === index
).map(region => ({
  label: region,
  value: region
}));

